import './DailyOverviewChart.css'
import { Chart, ArcElement, Tooltip, Legend } from 'chart.js';
import { Doughnut } from 'react-chartjs-2';
import useQuarantinedTests from '../../hooks/useQuarantinedTests';
import StatusBadge from './StatusBadge';

Chart.register(ArcElement, Tooltip, Legend);

const PlatformBreakdownChart = ({ selectedUnit }) => {
    const { data, loading, error } = useQuarantinedTests("All platforms", selectedUnit);

    if (loading) return (
        <div className="empty-card">
            <div className="metric-header">
                <h2>Platform</h2>
                <StatusBadge status="loading" label="Loading" />
            </div>
            <div className="chart-box">
                <img className="flashing" style={{ height: '100%' }} src={require('../../assets/loading-chart.png')} alt="Loading chart" />
            </div>
        </div>
    );

    if (error) return (
        <div className="empty-card">
            <div className="metric-header">
                <h2>Platform</h2>
                <StatusBadge status="error" label="Error" className="flashing" />
            </div>
            <div className="chart-box">
                <img className="flashing" style={{ height: '100%' }} src={require('../../assets/error-chart.png')} alt="Error chart" />
            </div>
        </div>
    );

    if (!data || data.length === 0) return (
        <div className="empty-card">
            <div className="metric-header">
                <h2>Platform</h2>
                <StatusBadge status="no-data" label="No data" className="flashing" />
            </div>
            <div className="chart-box">
                <img className="flashing" style={{ height: '100%' }} src={require('../../assets/no-data-chart.png')} alt="No data chart" />
            </div>
        </div>
    );

    // Group tests by repository/platform
    const platformCounts = data.reduce((acc, test) => {
        const platform = test.repository || 'Unknown';
        acc[platform] = (acc[platform] || 0) + 1;
        return acc;
    }, {});

    const platforms = Object.keys(platformCounts);
    const counts = Object.values(platformCounts);

    // Generate colors for each platform
    const colors = [
        '#4CAF50', '#F44336', '#2196F3', '#FF9800', '#9C27B0', 
        '#607D8B', '#795548', '#E91E63', '#00BCD4', '#FFC107'
    ];

    const chartData = {
        labels: platforms,
        datasets: [
            {
                data: counts,
                backgroundColor: colors.slice(0, platforms.length),
                borderWidth: 2,
                borderColor: '#fff'
            },
        ],
    };

    const options = {
        plugins: {
            legend: {
                display: false,
            },
            tooltip: {
                callbacks: {
                    label: function(context) {
                        const label = context.label || '';
                        const value = context.parsed;
                        const total = context.dataset.data.reduce((a, b) => a + b, 0);
                        const percentage = ((value / total) * 100).toFixed(1);
                        return `${label}: ${value} tests (${percentage}%)`;
                    }
                }
            }
        },
        maintainAspectRatio: false,
    };

    return (
        <div className="empty-card">
            <div className="metric-header">
                <h2>Platform</h2>
            </div>
            <div className="chart-box">
                <Doughnut data={chartData} options={options} />
            </div>
        </div>
    );
};

export default PlatformBreakdownChart;